

import {PropType} from 'vue';
import {Filters} from '../../../src/Entity/Filter';

const body = document.querySelector('body');

export default {
    props: {
        filters: {
            type: Object as PropType<Filters>,
        },
    },
    emits: ['apply', 'reset'],
    watch: {
        filters: {
            handler: function() {
                this.hasValue = this.filters.notEmpty();
            },
            deep: true,
        },
    },
    expose: ['toggle'],
    methods: {
        onClose() {
            this.toggle();
        },
        _showPanel() {
            body.classList.add('dt__filter-bodyOverlay');

            document.querySelector('body').addEventListener('click', (e) => {
                const target = e.target as Element;
                if (target.classList.value === 'dt__filter-overlay') {
                    body.classList.remove('dt__filter-bodyOverlay');
                    this.visible = false;
                }
            })
        },
        _hiddenPanel() {
            body.classList.remove('dt__filter-bodyOverlay');
            document.querySelector('body').removeEventListener('click', () => {
            });
        },
        toggle() {
            this.visible = !this.visible;
            if (this.visible) {
                this._showPanel();
            } else {
                this._hiddenPanel();
            }
        },
        onClear() {
            this.filters.reset();
            this.$emit('reset');
        },
        onApply() {
            this.$emit('apply', this.filters);
        },
    },
    mounted() {

    },
    data() {
        return {
            hasValue: this.filters.notEmpty(),
            visible: false,
        }
    },
}
